__turbopack_context__.v({
  "equalWidthColumns": "equal-width-columns-module-scss-module__F-TTmG__equalWidthColumns",
  "fullWidth": "equal-width-columns-module-scss-module__F-TTmG__fullWidth",
  "withDivider": "equal-width-columns-module-scss-module__F-TTmG__withDivider",
});
